const HYDRATE_CURRENT_REPORT = 'HYDRATE_CURRENT_REPORT';
const RESET_REPORT_SECTION = 'RESET_REPORT_SECTION';
const RUN_REPORT = 'RUN_REPORT';
const SET_DATE_FROM = 'SET_DATE_FROM';
const SET_DATE_TO = 'SET_DATE_TO';
const SET_GAME_TYPE = 'SET_GAME_TYPE';
const SET_IS_AGGREGATE = 'SET_IS_AGGREGATE';
const SET_IS_DATE_RANGE_FROM_SEASONS = 'SET_IS_DATE_RANGE_FROM_SEASONS';
const SET_FRANCHISE_ID = 'SET_FRANCHISE_ID';
const SET_POSITION = 'SET_POSITION';
const SET_REPORT_NAME = 'SET_REPORT_NAME';
const SET_REPORT_TIME_FRAME = 'SET_REPORT_TIME_FRAME';
const SET_SEASON_FROM = 'SET_SEASON_FROM';
const SET_SEASON_TO = 'SET_SEASON_TO';

export default {
    HYDRATE_CURRENT_REPORT,
    RESET_REPORT_SECTION,
    RUN_REPORT,
    SET_DATE_FROM,
    SET_DATE_TO,
    SET_GAME_TYPE,
    SET_IS_AGGREGATE,
    SET_IS_DATE_RANGE_FROM_SEASONS,
    SET_FRANCHISE_ID,
    SET_POSITION,
    SET_REPORT_NAME,
    SET_REPORT_TIME_FRAME,
    SET_SEASON_FROM,
    SET_SEASON_TO,
};
